import { render, staticRenderFns } from "./AliPay.vue?vue&type=template&id=18d5af24&scoped=true"
import script from "./AliPay.vue?vue&type=script&lang=js"
export * from "./AliPay.vue?vue&type=script&lang=js"
import style0 from "./AliPay.vue?vue&type=style&index=0&id=18d5af24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d5af24",
  null
  
)

export default component.exports